"use strict";

const BC_Input = function (EWS) {
    this.EWS = EWS;
    this.Menu = null;
    this.Current = null;

    const me = this;

    this.EWS.Command.AddMenu("BC_Input_Results", (_control, _name, menu) => {
        menu.innerHTML = "";
        EWS.Command.HideAllMenus();
    }, (_control, _name, menu, menuArgs) => {
        if (EC_Fmt.isNull(menuArgs.html)) {
            EWS.Command.HideAllMenus();
        } else {
            menu.innerHTML = menuArgs.html;
            menu.style.minWidth = `${menuArgs.width}px`;
            menu.style.maxWidth = `${menuArgs.maxWidth}px`;

            const myField = menuArgs.field;
            // Task 1073260: Ctrl+click on a Universal Search result that you don't have permission for takes the user to a 404 page
            const menuItems = menu.querySelectorAll(".ews-menu-item:not(.Disabled)");

            for (let i = 0, len = menuItems.length; i < len; i++) {
                menuItems[i].addEventListener("click", (event) => {
                    const link = event.currentTarget;
                    const url = link.getAttribute("value");
                    const hidden = myField.parentElement.querySelector("input[type=hidden]");
                    if (menuArgs.enableCtrl && (event.ctrlKey || event.metaKey)) {
                        hidden.value = "";
                        hidden.setAttribute("index", "");
                        EC_Fmt.TriggerEvent(hidden, "change");
                        myField.value = "";
                        // Task 1010798: Recently Visited stays open when control clicking the link
                        document.body.focus();

                        EWS.Command.HideAllMenus();
                        window.open(url);
                    } else {
                        hidden.value = url;
                        hidden.setAttribute("index", link.getAttribute("index"));
                        EC_Fmt.TriggerEvent(hidden, "change");

                        myField.value = link.querySelector(".ews-menu-label").innerText;
                        myField.focus();

                        if (!EC_Fmt.isNull(menuArgs.afterChange)) {
                            EWS.Command.Execute(menuArgs.afterChange, {
                                field: hidden,
                                input: myField
                            });
                        }

                        EWS.Command.HideAllMenus();
                        EWS.Input.UnifiedSearch();
                    }
                });
            }

            me.Menu = menu;
        }
    });

    this.Init(document.body);
};

BC_Input.prototype.Init = function (container) {
    const me = this;
    if (!me.initializedUnifiedSearch) {
        const unifiedSearch = document.getElementById("ews-UnifiedSearch-input");
        if (unifiedSearch) {
            me.InitSearch(unifiedSearch);
        }
        me.initializedUnifiedSearch = true;
    }

    const inputs = container.querySelectorAll("input[type='html']");
    for (let i = 0, len = inputs.length; i < len; i++) {
        if (inputs[i].getAttribute("initialized") !== "true") {
            inputs[i].setAttribute("initialized", "true");
            me.InitHtml(inputs[i]);
        }
    }
};

BC_Input.prototype.InitSearch = function (field) {
    const me = this;
    let id = field.id;
    const name = field.name;

    const icon = (field.getAttribute("icon") || "");
    const section = document.createElement("section");
    section.style.width = "100%";

    if (!id.startsWith("ews-")) {
        id = `ews-${id}`;
    }
    if (id.endsWith("-input")) {
        id = id.substring(0, id.length - 6);
    }

    field.classList.remove("Disabled");

    const hidden = document.createElement("input");
    hidden.type = "hidden";
    hidden.id = `${id}-field`;
    hidden.name = name;
    hidden.value = (field.getAttribute("value") || "");
    hidden.setAttribute("class", (field.getAttribute("selector") || ""));

    const input = document.createElement("input");
    input.type = "text";
    input.id = `${id}-input`;
    input.value = (field.getAttribute("display") || (field.getAttribute("value") || ""));
    input.setAttribute("class", (field.getAttribute("class") || "") + (icon !== "" ? " ews-input-has-icon" : ""));
    input.setAttribute("style", (field.getAttribute("style") || ""));
    input.setAttribute("backend", (field.getAttribute("backend") || ""));
    input.setAttribute("autocomplete", "off");
    input.autocomplete = "off";
    input.placeholder = "Search for anything...";

    section.appendChild(hidden);
    section.appendChild(input);

    if (EC_Fmt.isMobile) {
        input.addEventListener("click", () => {
            const dialogArgs = {
                InputName: name,
                Input: input,
                field
            };

            // Task 1028319: iOS Universal Search does not always display when focused
            const dialogContent = "<div class=ajaxinput-mobile-wrapper>"
                + "<div class=ajax-input-delete-wrapper>"
                + "<span class=ews-icon-close></span>"
                + "</div>"
                + "</div>"
                + "<section class=ajaxinput-list-mobile>"
                + "<div class=List></div>"
                + "<div class=Results></div>"
                + "</section>";

            const Dialog = ECP.Dialog.ShowDialog("Search", dialogContent, {
                width: 80,
                height: 80,
                confirmButtonTitle: "Cancel",
                confirmButtonAction(dialog) {
                    ECP.Dialog.CloseDialog(dialog);
                }
            });

            // Mobile Style
            const dialogStyle = "width:100%;height:100%;border-radius:0";
            const containerStyle = "height:100%;width:100%;top:0;left:0;max-width:unset;";
            const titleStyle = "display:none";
            // EC-18058: Cancel button display is incorrect on mobile when using the Unified Search on iOS
            const footerStyle = "position:absolute;top:0;right:0;z-index:20;width:85px;min-height:48px;background-color:var(--bg);padding:0 20px;bottom:unset;left:unset;box-shadow:0 0 0;";
            const ajaxinputWrapStyle = "position:fixed;top:0;z-index:5;width:calc(100% - 85px);padding:2px 0 0 18px;height:48px;display:flex;justify-content:center;align-items:center;background:var(--bg);border-bottom:none;right:85px";
            const ajaxinputStyle = "background:var(--neutral-20);border:none;border-radius:16px;height:34px!important;padding-left:40px;";
            const ajaxClearStyle = "top:5px;right:0;z-index:15;text-align:center;";
            const searchIconStyle = "position:absolute;left:16px;width:48px;text-align:center;font-size:16px;color:var(--text);";
            const listSectionStyle = "flex:1;margin-top:20px;padding:0;border-top:solid 6px var(--neutral-120);overflow:auto;";

            Dialog.firstElementChild.setAttribute("style", dialogStyle);
            Dialog.querySelector(".ecp-dialog-container").setAttribute("style", containerStyle);
            Dialog.querySelector(".ecp-dialog-title").setAttribute("style", titleStyle);
            Dialog.querySelector(".ecp-dialog-footer").setAttribute("style", footerStyle);
            Dialog.querySelector(".ecp-dialog-content").style.cssText += "position:relative;padding:0;max-height:calc(100% - 32px);background:var(--bg);display:flex;flex-direction:column;";
            Dialog.querySelector(".ecp-dialog-confirm-button").type = "ghost";
            Dialog.querySelector(".ecp-dialog-confirm-button").innerHTML = "Cancel";
            Dialog.querySelector(".ajaxinput-mobile-wrapper").setAttribute("style", ajaxinputWrapStyle);
            Dialog.querySelector(".ajax-input-delete-wrapper").setAttribute("style", ajaxClearStyle);
            Dialog.querySelector(".ajaxinput-list-mobile").setAttribute("style", listSectionStyle);

            const ajaxSearchIcon = document.createElement("span");
            ajaxSearchIcon.classList.add("ews-icon-search");
            ajaxSearchIcon.setAttribute("style", searchIconStyle);

            Dialog.querySelector(".ajaxinput-mobile-wrapper").appendChild(ajaxSearchIcon);

            Dialog.querySelector(".ecp-dialog-close").remove();

            let inputField = dialogArgs.Input;

            inputField = inputField.cloneNode(true);

            Dialog.querySelector(".ecp-dialog-content .ajaxinput-mobile-wrapper").appendChild(inputField);

            inputField.setAttribute("style", ajaxinputStyle);
            inputField.id = `ews-${dialogArgs.InputName}-mobileinput`;

            const displayRecentlyVisited = (mobileUniversalSearchInput) => {
                setTimeout(() => {
                    if (mobileUniversalSearchInput.value.length === 0 && mobileUniversalSearchInput === document.activeElement) {
                        let recentlyVisited = EC_Fmt.GetLocalStorageValue(`RecentlyVisitedPages_${UserID}`);
                        if (recentlyVisited) {
                            recentlyVisited = JSON.parse(recentlyVisited);
                        }
                        const recentlyVisitedResult = { categories: true, category: [{ name: "RecentlyVisited", alias: "Recently Visited", result: [] }] };

                        for (let i = recentlyVisited.pages.length - 1; i >= 0; i--) {
                            if (recentlyVisited.pages[i].title !== document.title) {
                                recentlyVisitedResult.category[0].result.push({ display: recentlyVisited.pages[i].title, value: recentlyVisited.pages[i].URL });
                            }
                        }

                        me.DisplayResults(mobileUniversalSearchInput, recentlyVisitedResult, null, true, true);
                    }
                }, 100);
            };

            EC_Fmt.AfterInput(inputField, 0, 250, (searchInput, search) => {
                if (!EC_Fmt.isNull(search) && search.length > 1) {
                    const data = new FormData();

                    data.append("SearchStr", search);

                    me.Post(searchInput, searchInput.getAttribute("backend"), data, (PostInputField, universalSearchResult) => {
                        me.DisplayResults(PostInputField, universalSearchResult, undefined, true, true);
                    });
                } else {
                    displayRecentlyVisited(searchInput);
                }
            }, true);

            Dialog.querySelector(".ecp-dialog-content .ajaxinput-list-mobile").addEventListener("click", (event) => {
                const item = event.target.closest(".ews-menu-item");

                if (item && Dialog.querySelector(".ecp-dialog-content .ajaxinput-list-mobile").contains(item)) {
                    item.style.backgroundColor = "var(--neutral-20)";

                    // Task 740917: Grayed-out dashboard is clickable in mobile-view and returns 404 error page
                    if (item.getAttribute("value")) {
                        window.location.href = item.getAttribute("value");
                    }
                }
            });
            Dialog.querySelector(".ajaxinput-mobile-wrapper .ajax-input-delete-wrapper").addEventListener("click", () => {
                inputField.value = "";
                inputField.focus();
            });

            // Task 634038: Universal search does not auto-focus on the input field on mobile
            requestAnimationFrame(() => {
                const mobileUniversalSearchInput = document.getElementById("ews-UnifiedSearch-mobileinput");
                if (mobileUniversalSearchInput) {
                    mobileUniversalSearchInput.focus();
                }

                displayRecentlyVisited(mobileUniversalSearchInput);
            });
        });
    } else {
        const displayRecentlyVisited = () => {
            setTimeout(() => {
                if (input.value.length === 0 && input === document.activeElement) {
                    let recentlyVisited = EC_Fmt.GetLocalStorageValue(`RecentlyVisitedPages_${UserID}`);
                    if (recentlyVisited) {
                        recentlyVisited = JSON.parse(recentlyVisited);
                    }
                    const recentlyVisitedResult = { categories: true, category: [{ name: "RecentlyVisited", alias: "Recently Visited", result: [] }] };

                    for (let i = recentlyVisited.pages.length - 1; i >= 0; i--) {
                        if (recentlyVisited.pages[i].title !== document.title) {
                            recentlyVisitedResult.category[0].result.push({ display: recentlyVisited.pages[i].title, value: recentlyVisited.pages[i].URL });
                        }
                    }

                    me.DisplayResults(input, recentlyVisitedResult, null, true, true);
                }
            }, 100);
        };

        input.addEventListener("click", (event) => {
            event.stopPropagation();
        });

        input.addEventListener("focus", () => {
            if (input.value.length > 0) {
                input.setSelectionRange(input.value.length, input.value.length);
            } else {
                displayRecentlyVisited();
            }
        });

        EC_Fmt.AfterInput(input, 0, 250, (InnerInput, search) => {
            if (!EC_Fmt.isNull(search) && search.length > 1) {
                const data = new FormData();

                hidden.value = search;
                hidden.setAttribute("index", "");

                data.append("SearchStr", search);

                document.querySelector(".clear-input-button").classList.remove("hidden");

                me.Post(InnerInput, InnerInput.getAttribute("backend"), data, (InnerInput2, result) => {
                    me.DisplayResults(InnerInput2, result, result.categories, true, true);
                });
            } else {
                displayRecentlyVisited();
            }
        }, true);

        input.addEventListener("keydown", (event) => {
            switch (event.key) {
                case "Tab":
                case "Enter":

                    if (me.Menu) {
                        const index = parseInt((me.Menu.getAttribute("index") || ""));
                        if (EC_Fmt.isInteger(index) && index >= 0) {
                            EC_Fmt.TriggerEvent(me.Menu.querySelector(`.ews-menu-item[index='${index}']`), "click");
                        } else if (event.key === "Enter") {
                            const firstMenuItem = me.Menu.querySelector("div.ews-menu-item");
                            if (firstMenuItem?.getAttribute("value")) {
                                EC_Fmt.TriggerEvent(firstMenuItem, "click");
                            }
                        }
                    }

                    EWS.Command.HideAllMenus();
                    return true;

                case "ArrowUp":
                    if (me.Menu) {
                        let index = parseInt((me.Menu.getAttribute("index") || ""));

                        if (EC_Fmt.isInteger(index) && index > 0) {
                            index -= 1;

                            const item = me.Menu.querySelector(`.ews-menu-item[index='${index}']`);
                            const scroll = me.Menu.scrollTop;
                            let scrollTo;

                            const menuItems = me.Menu.querySelectorAll(".ews-menu-item.highlight");
                            for (let i = 0, len = menuItems.length; i < len; i++) {
                                menuItems[i].classList.remove("highlight");
                            }

                            item.classList.add("highlight");

                            if (item) {
                                hidden.value = item.getAttribute("value");
                                hidden.setAttribute("index", item.getAttribute("index"));
                                input.value = item.querySelector(".ews-menu-label").innerHTML;
                                input.setSelectionRange(input.value.length, input.value.length);

                                me.Menu.setAttribute("index", index);
                                me.Menu.scrollTop = 0;

                                const itemPosition = item.getBoundingClientRect();

                                if ((itemPosition.top + item.offsetHeight) > (scroll + me.Menu.offsetHeight)) {
                                    scrollTo = scroll + (itemPosition.top - scroll) + 1;
                                } else if (itemPosition.top < scroll) {
                                    scrollTo = scroll - (scroll - itemPosition.top);
                                } else {
                                    scrollTo = scroll;
                                }
                            } else {
                                scrollTo = scroll;
                            }

                            me.Menu.scrollTop = scrollTo;
                        }
                    }
                    return false;

                case "ArrowDown":
                    if (me.Menu) {
                        const menuItems = me.Menu.querySelectorAll(".ews-menu-item");
                        let index = parseInt((me.Menu.getAttribute("index") || ""));

                        if (!EC_Fmt.isInteger(index)) {
                            index = 0;
                        } else if (index < (menuItems.length - 1)) {
                            index += 1;
                        } else if (index > (menuItems.length - 1)) {
                            index = 0;
                        }

                        const item = me.Menu.querySelector(`.ews-menu-item[index='${index}']`);
                        const scroll = me.Menu.scrollTop;
                        let scrollTo;

                        for (let i = 0, len = menuItems.length; i < len; i++) {
                            menuItems[i].classList.remove("highlight");
                        }

                        if (item) {
                            item.classList.add("highlight");

                            hidden.value = item.getAttribute("value");
                            hidden.setAttribute("index", item.getAttribute("index"));
                            input.value = item.querySelector(".ews-menu-label").innerHTML;
                            input.setSelectionRange(input.value.length, input.value.length);

                            me.Menu.setAttribute("index", index);
                            me.Menu.scrollTop = 0;

                            const itemPosition = item.getBoundingClientRect();

                            if ((itemPosition.top + item.offsetHeight) > (scroll + me.Menu.offsetHeight)) {
                                scrollTo = scroll + (itemPosition.top - scroll) + 1;
                            } else if (itemPosition.top < scroll) {
                                scrollTo = scroll - (scroll - itemPosition.top);
                            } else {
                                scrollTo = scroll;
                            }
                        } else {
                            scrollTo = scroll;
                        }

                        me.Menu.scrollTop = scrollTo;
                    }
                    return false;

                default:
                    if (me.Menu) {
                        me.Menu.setAttribute("index", "-1");
                    }
                    return true;
            }
        });
    }

    let button = field.parentElement.querySelector(".ews-input-action");
    if (!button) {
        const action = field.getAttribute("action");
        button = document.createElement("div");
        button.classList.add("ews-input-icon");
        button.classList.add("ews-input-action");
        button.setAttribute("action", action);
        if (icon !== "") {
            const iconElement = document.createElement("span");
            iconElement.classList.add(icon);
            button.appendChild(iconElement);
        }
    }

    button.addEventListener("click", () => {
        me.Submit(input, true);
    });
    button.style.top = "";

    section.appendChild(button);

    field.parentElement.replaceChild(section, field);

    const laptopClearIcon = document.createElement("span");
    laptopClearIcon.classList.add("ews-icon-close", "clear-input-button", "hidden");

    section.parentElement.appendChild(laptopClearIcon);

    input.addEventListener("blur", () => {
        me.Menu = null;
    });

    laptopClearIcon.addEventListener("click", () => {
        if (!laptopClearIcon.classList.contains("hidden")) {
            input.value = "";
            hidden.value = "";
            laptopClearIcon.classList.add("hidden");
        }
    });

    this.EWS.Command.ShowMenu("BC_Input_Results", input.parentElement, {
        html: "",
        // width: 0,
        maxWidth: (EWS.windowInnerWidth > 0 ? EWS.windowInnerWidth : window.screen.width) - 15,
        persistent: true,
        field: input,
        enableCtrl: true
    });

    if (!EC_Fmt.isNull(section.getAttribute("onchange"))) {
        hidden.addEventListener("change", () => {
            EWS.Command.Execute(section.getAttribute("onchange"), {
                field: hidden,
                input,
                button
            });
        });
    }
};

BC_Input.prototype.InitHtml = function (field) {
    // Task 428664
    const name = field.name;
    const id = EC_Fmt.NullChk(field.id, name);

    const section = document.createElement("section");
    section.classList.add("ews-input-html-edit");
    section.setAttribute("style", (field.getAttribute("style") || ""));
    section.style.resize = "both";
    section.style.overflow = "auto";

    if (section.style.width === "" || section.style.width === "0px") {
        section.style.width = "100%";
    }

    let height = 300;
    const templateHeight = field.style.height.replace("px", "");
    if (EC_Fmt.isInteger(templateHeight) && templateHeight !== "0") {
        height = parseFloat(templateHeight);
        if (height < 300) {
            height = 300;
        }
    }

    section.style.height = `${height}px`;

    const mutationObserver = new MutationObserver((mutations) => {
        for (let i = 0, len = mutations.length; i < len; i++) {
            const mutation = mutations[i];
            if (mutation.type === "attributes") {
                const target = mutation.target;
                if (target.querySelector("iframe")) {
                    target.querySelector("iframe").style.height = `${target.offsetHeight - 80}px`;
                }
            }
        }
    });
    mutationObserver.observe(section, {
        attributeName: "style", attributes: true, characterDataOldValue: true, childList: false
    });

    const body = document.createElement("textarea");
    body.id = id;
    body.name = name;
    body.classList.add("ui-box-size");
    body.value = field.value;
    body.setAttribute("type", "html");
    body.setAttribute("maxlength", EC_Fmt.Null2EmptyStr(field.getAttribute("maxlength")));

    section.appendChild(body);
    field.parentElement.replaceChild(section, field);

    if (!EC_Fmt.isNull(EWS.TinymceEdit)) {
        EWS.TinymceEdit(`#${id}`, "", "", {
            height: height - 76,
            toolbar: ["undo redo fontsizeselect bold italic hr bullist numlist link addreport table code image"],
            plugins: ["table link code hr addreport image"]
        });
    }
};

BC_Input.prototype.DisplayResults = function (field, result, categories, persistent, enableCtrl, afterChange) {
    let html = "";
    let count = 0;

    if (categories || result.categories) {
        for (let i = 0; i < result.category.length; i++) {
            if (result.category[i].result.length > 0) {
                html += `<div class="search-result-category">${result.category[i].alias}</div>`;

                for (let j = 0; j < result.category[i].result.length; j++) {
                    const menuItem = result.category[i].result[j];
                    if (menuItem.hasPermission === "false") {
                        html += `<div class="ews-menu-item Disabled"style=padding-left:10px;height:32px title="${menuItem.PermissionMessage}"index=1000000>`;
                    } else {
                        html += `<div class=ews-menu-item style=padding-left:10px;height:32px value='${menuItem.value}'index=${count}>`;
                        count += 1;
                    }

                    // Task 1079094: Record title with more than 3 lines can cause the recently visited pages display to overlap the text
                    html += " <div class=ews-menu-icon></div>"
                        + ` <div class=ews-menu-label>${EC_Fmt.RemoveHTMLFromStr(menuItem.display)}</div>`
                        + "</div>";
                }
            }
        }
    }

    if (!EC_Fmt.isNull(result.message)) {
        html += `<div style="color:var(--text-secondary);margin:10px 10px 5px 10px;border-top:1px var(--neutral-50) solid">${result.message}</div>`;
    }

    if (EC_Fmt.isMobile && field.closest(".ajaxinput-mobile-wrapper")) {
        if (html !== "") {
            field.closest(".ecp-dialog-content").querySelector(".ajaxinput-list-mobile .Results").innerHTML = html;
        }
    } else if (html !== "") {
        this.EWS.Command.ShowMenu("BC_Input_Results", field.parentElement, {
            html,
            width: (field.offsetWidth - 2),
            persistent,
            field,
            enableCtrl,
            afterChange
        });
    }
};

BC_Input.prototype.Post = function (field, url, data, callback) {
    const me = this;

    EWS.VerifySession(() => {
        fetch(url, {
            credentials: "same-origin",
            method: "post",
            body: data
        }).then(response => response.json()).then((result) => {
            me.Current = result;
            if (!EC_Fmt.isNull(callback)) {
                callback(field, result);
            }
        });
        gtag("event", "searchExecuted", { data });
    });
};

BC_Input.prototype.Submit = function (field, execute) {
    const parent = field.parentElement;
    if (parent) {
        const HiddenInput = parent.querySelector("input[type=hidden]");
        const icon = parent.querySelector(".ews-input-icon");

        if (EC_Fmt.isInteger(HiddenInput.getAttribute("index"))) {
            const action = (icon.getAttribute("action") || "");

            if (action !== "") {
                requestAnimationFrame(() => {
                    eval(action);
                });
            }
        } else if (!EC_Fmt.isNull(this.Current)) {
            let value = "";
            let display = "";

            if (!EC_Fmt.isNull(this.Current)) {
                if (this.Current.categories) {
                    for (let i = 0; i < this.Current.category.length; i++) {
                        if (this.Current.category[i].result.length > 0) {
                            for (let j = 0; j < this.Current.category[i].result.length; j++) {
                                if (value === "") {
                                    value = this.Current.category[i].result[j].value;
                                    display = this.Current.category[i].result[j].display;
                                } else {
                                    break;
                                }
                            }
                        }
                    }
                } else if (this.Current.result) {
                    for (let i = 0; i < this.Current.result.length; i++) {
                        if (value === "") {
                            value = this.Current.result[i].value;
                            display = this.Current.result[i].value;
                        } else {
                            break;
                        }
                    }
                }
            }

            if (value !== "") {
                const hidden = field.parentElement.querySelector("input[type=hidden]");
                hidden.value = value;
                hidden.setAttribute("index", "0");
                EC_Fmt.TriggerEvent(hidden, "change");
                field.value = display;

                if (execute) {
                    const action = (icon.getAttribute("action") || "");

                    if (action !== "") {
                        requestAnimationFrame(() => {
                            eval(action);
                        });
                    }
                }
            }
        }
    }
};

BC_Input.prototype.UnifiedSearch = function () {
    requestAnimationFrame(() => {
        let url = document.getElementById("ews-UnifiedSearch-input").parentElement.querySelector("#ews-UnifiedSearch-field").value;

        if (!EC_Fmt.isNull(url)) {
            if (EC_Fmt.isMobile && !url.toLowerCase().includes("forcedesktop=true")) {
                if (url.includes("?")) {
                    url += "&";
                } else {
                    url += "?";
                }

                url += "ForceDesktop=True";
            }

            window.location.href = url;
        }
    });
};

(function (EWS) {
    // eslint-disable-next-line no-shadow
    EWS.Ready((EWS) => {
        EWS.Input = new BC_Input(EWS);
    });
}(EWS));
